import React from "react";
import { useLocation, Navigate, Link } from "react-router-dom";
import { ChevronRight, FileText } from "lucide-react";
import { PageHeader } from "../components/sections/Shared";
import Seo from "../components/Seo";
import { LEGAL_DOCS } from "../data/legal";

export default function LegalDoc() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\//, "").replace(/\/$/, "");
  const doc = LEGAL_DOCS[slug];
  if (!doc) return <Navigate to="/404" replace />;

  return (
    <>
      <Seo title={doc.seoTitle} description={doc.seoDescription} path={`/${doc.slug}`} />
      <PageHeader
        eyebrow={doc.eyebrow}
        title={doc.title}
        accent={doc.accent}
        description={`${doc.intro} Last updated ${doc.updated}.`}
      />
      <section className="py-16 md:py-20 bg-white">
        <div className="container-518 grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-3 lg:sticky lg:top-28 self-start h-fit">
            <div className="bg-slate-50 rounded-2xl border border-slate-200 p-5">
              <div className="flex items-center gap-2 mb-4">
                <FileText className="w-4 h-4 text-[#f59321]" />
                <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500">Contents</span>
              </div>
              <ol className="space-y-2">
                {doc.sections.map((s, i) => (
                  <li key={i}>
                    <a href={`#sec-${i}`} className="flex items-start gap-1.5 text-sm text-slate-600 hover:text-[#f59321] font-medium">
                      <ChevronRight className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                      {s.title}
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          </aside>

          <article className="lg:col-span-9 max-w-3xl" data-testid={`legal-doc-${doc.slug}`}>
            {doc.sections.map((s, i) => (
              <div key={i} id={`sec-${i}`} className="mb-10 scroll-mt-28">
                <h2 className="font-display text-2xl md:text-3xl font-extrabold text-[#0f2847] mb-3">{s.title}</h2>
                <p className="text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
            <div className="mt-12 p-5 rounded-2xl bg-slate-50 border border-slate-200 text-sm text-slate-600">
              OBLED Corporation d/b/a 518 Courier · 1321 Pleasant St, Schenectady, NY 12303
              <Link to="/contact" className="ml-1 text-[#f59321] font-semibold hover:underline">Questions? Contact us.</Link>
            </div>
          </article>
        </div>
      </section>
    </>
  );
}
